import { render, staticRenderFns } from "./CheckDialog.vue?vue&type=template&id=5290ffbc"
import script from "./CheckDialog.vue?vue&type=script&lang=js"
export * from "./CheckDialog.vue?vue&type=script&lang=js"
import style0 from "./CheckDialog.vue?vue&type=style&index=0&id=5290ffbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports